module.exports = __webpack_public_path__ + "static/media/boat-img-27.90bc5cf4.jpg";